import { memo, useState, useEffect, useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useStore } from 'store/StoreContext';
import { initialUserData, callGetUserApi } from 'requests/RequestUser';
import { findSexTypeNameByKey } from 'consts/SexConst';
import { findCountryTypeNameByKey } from 'consts/CountryConst';
import { findPrefectureTypeNameByKey } from 'consts/PrefectureConst';
import { UserForm } from 'components/templates/ProfileEditTemplate';
import { copyObject } from 'common/copyObject';
import { RoutePath } from 'consts/RoutePath';
import { CircularProgress, Backdrop } from '@material-ui/core';
import classes from './override.module.scss';
import { HttpStatus } from 'consts/HttpStatus';
import { Hr } from 'components/atoms/Hr';
import { BirthDay } from 'components/molecules/BirthDay';

type Props = {};

export const AccountInfoTemplate = memo((_props: Props) => {
	const history = useHistory();
	const [store] = useStore();

	// ログインユーザ情報を取得する
	const [userData, setUserData] = useState<UserForm>({
		birthYear: '',
		birthMonth: '',
		birthDate: '',
		...initialUserData,
	});
	const [getUserLoading, setGetUserLoading] = useState(false);
	useEffect(() => {
		const execute = async () => {
			setGetUserLoading(true);
			const getUserResult = await callGetUserApi();
			if (getUserResult.status !== HttpStatus.OK || !getUserResult.data) {
				history.push(RoutePath.ERROR);
				return;
			}
			if (!!store.loginUserData.gidpk && getUserResult.status === HttpStatus.OK && !!getUserResult.data) {
				const user = copyObject(getUserResult.data);
				const birth = user.birth ? new Date(user.birth) : undefined;
				setUserData({
					birthYear: !!birth ? birth.getFullYear().toString() : '',
					birthMonth: !!birth ? (birth.getMonth() + 1).toString() : '',
					birthDate: !!birth ? birth.getDate().toString() : '',
					...user,
				});
			}
			setGetUserLoading(false);
		};
		execute();
	}, []);

	const scrollRef = useRef(null);
	useEffect(() => {
		scrollRef.current.scrollIntoView();
		document.title = 'GakkenIDマイページ｜登録情報';
	}, []);

	return (
		<>
			<Backdrop className={classes.backdrop} open={getUserLoading}>
				<CircularProgress color="inherit" />
			</Backdrop>
			<section className="section mypage" ref={scrollRef}>
				<div className="breadcrumb">
					<ul>
						<li>
							<Link to={RoutePath.MY_PAGE}>マイページTOP</Link>
						</li>
						<li>登録情報</li>
					</ul>
				</div>

				<h1 className="page-head">登録情報</h1>

				<div className="section-in">
					<div className="info-box">
						<div className="info-head">GakkenID</div>
						<div className="info-txt">{userData.gid || '　'}</div>
					</div>
					<Hr />
					{!store.loginUserData.isChild && (
						<>
							<div className="info-box">
								<div className="info-head">メールアドレス</div>
								<div className="info-txt">{userData.mailaddress_1 || '　'}</div>
							</div>
							<Hr />
						</>
					)}
					<div className="info-box">
						<div className="info-head">お名前（全角）</div>
						<div className="info-txt">{`${userData.lastname}${'　'}${userData.firstname}`}</div>
					</div>
					<Hr />
					<div className="info-box">
						<div className="info-head">お名前（カナ）</div>
						<div className="info-txt">{`${userData.kana_lastname}${'　'}${userData.kana_firstname}`}</div>
					</div>
					<Hr />
					<div className="info-box">
						<div className="info-head">生年月日</div>
						<div className="info-txt">
							<BirthDay birth={userData.birth} isFlexStart={true} />
						</div>
					</div>
					<Hr />
					<div className="info-box">
						<div className="info-head">性別</div>
						<div className="info-txt">{findSexTypeNameByKey(userData.sex) || '　'}</div>
					</div>
					<Hr />
					{!store.loginUserData.isChild && (
						<>
							<div className="info-box">
								<div className="info-head">電話番号</div>
								<div className="info-txt">{userData.tel || '　'}</div>
							</div>
							<Hr />
							<div className="info-box">
								<div className="info-head">郵便番号</div>
								<div className="info-txt">{userData.zip || '　'}</div>
							</div>
							<Hr />
							<div className="info-box">
								<div className="info-head">都道府県</div>
								<div className="info-txt">{findPrefectureTypeNameByKey(userData.pref_cd) || '　'}</div>
							</div>
							<Hr />
							<div className="info-box">
								<div className="info-head">市区町村</div>
								<div className="info-txt">{userData.address_2 || '　'}</div>
							</div>
							<Hr />
							<div className="info-box">
								<div className="info-head">町名・番地</div>
								<div className="info-txt">{userData.address_3 || '　'}</div>
							</div>
							<Hr />
							<div className="info-box">
								<div className="info-head">マンション名</div>
								<div className="info-txt">{userData.address_4 || '　'}</div>
							</div>
							<Hr />
							<div className="info-box">
								<div className="info-head">ニックネーム</div>
								<div className="info-txt">{userData.nickname || '　'}</div>
							</div>
							<Hr />
							<div className="info-box">
								<div className="info-head">国</div>
								<div className="info-txt">{findCountryTypeNameByKey(userData.country) || '　'}</div>
							</div>
							<Hr />
						</>
					)}
					<div className="info-box">
						<div className="info-head">同意内容</div>
						<div className="info-txt">
							<ul>
								{userData.data_util_agree_flg === 1 ? <li>サービス向上のためデータ活用に同意する</li> : null}
								{userData.data_util_agree_flg === 0 ? <li>　</li> : null}
							</ul>
						</div>
					</div>
					{/* {!store.loginUserData.isChild && (
						<>
							<Hr />
							<div className="info-box">
								<div className="info-head">決済の利用権限</div>
								<div className="info-txt">{userData.payment_not_flg === 0 ? '権限あり' : '権限なし'}</div>
							</div>
						</>
					)} */}
					{store.loginUserData.isChild ? (
						<div className={classes.memberNote}>
							<span>{`※登録情報は「代表者」など権限のあるユーザーのみ変更可能です`}</span>
						</div>
					) : (
						<div className="btn-box">
							<div className="btn gr">
								<Link to={RoutePath.PROFILE_EDIT}>
									<span>プロフィールを変更する</span>
								</Link>
							</div>
						</div>
					)}
				</div>
			</section>
		</>
	);
});
